import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _11M_BIODIVERSITY_PRESERVATION:Partial<EcosystemServiceModel> ={
  id:'biodiversity-preservation-marine',
  pos:11,
  image: "/images/ecoservices/biodiversity_s.jpeg",
  code: ["2.2.2.3"],
  unit:'biodiversity',
  assetType:'species',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'defensiveCosts',
      name:"Defensive costs",
      unit: "m2",
      element: "Posidonia",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
        { id: "habitatRichness", name: "Habitat Richness Index", included: true },
        { id: "mitigation", name: "Mitigation Index", included: true },
      ],
      valueIndices: []
    },    
    {
      id: 'avoidedCost',
      name:"Avoided prices",
      unit: "shoots",
      element: "Posidonia",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
        { id: "habitatRichness", name: "Habitat Richness Index", included: true },
        { id: "mitigation", name: "Mitigation Index", included: true },
      ],
      valueIndices: []
    },

    // {
    //   id: 'contingent',
    //   name:"Contingent Valuation",
    //   unit: "shoots",
    //   element: "Posidonia",
    //   altUnits: null,
    //   qtyIndices: [
    //     { id: "quality", name: "Quality Index", included: true },
    //     { id: "habitatRichness", name: "Habitat Richness Index", included: true },
    //     { id: "mitigation", name: "Mitigation Index", included: true },
    //   ],
    //   valueIndices: []
    // },
  ],
  hasInitialValue:true,
  disaggregatedInitialValues:['restorationInterventions'],
  disaggregatedMonetaryValues:[ 
    'administrativeManagementCosts', 
    'scientificMonitoringCosts',
    'educationalPublicActivitiesCosts', 
    'maintenanceCosts', 
    'useOperationalCosts', 
    'conservationProjects'
  ],
  // disaggregatedMonetaryValues:[
  //   'legalFramework', 'operationalManagement','posidoniaOperations', 'technicalMooringManagement', 'monitoringAndCartography', 'eventsAndEnvironmentalEducation', 'communicationAndOutreach'
  // ],
  restrictions:{
    onlyAllowed:['marine']
  }

}

